import { render } from "./ReceiptStepComponent.vue?vue&type=template&id=fedc81f8&ts=true"
import script from "./ReceiptStepComponent?vue&type=script&lang=ts"
export * from "./ReceiptStepComponent?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/atlantis/atlantis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__